import React from 'react';
import '../assets/style/home.css'
import MainLoader from '../components/shared/MainLoader';

export default function Home() {
    return (
        <>
            <MainLoader />
            <div className="container home">
                <div className="row">
                    <div className="col-12">
                        <div className="profile-bg m-auto">
                            <img src="/images/profileimg.png" alt="" className='pf-img' />
                        </div>
                        <h1 className='text-center name'>Ajay Kumar</h1>
                        <div className="row basic-info text-center">
                            <div className="col-5 col-md-3">
                                <h2>4+</h2>
                                <h5>Years of Experience</h5>
                            </div>
                            <div className="col-5 col-md-3">
                                <h2>30+</h2>
                                <h5>Projects Completed</h5>
                            </div>
                            <div className="col-5 col-md-3">
                                <h2>10+</h2>
                                <h5>Technologies Worked With</h5>
                            </div>
                            <div className="col-5 col-md-3">
                                <h2>10+</h2>
                                <h5>Happy Clients</h5>
                            </div>
                        </div>
                        <div className="row bio">
                            <div className="col-12 text-center">
                                <h2 className='job-title'>Frontend & Full Stack Developer<span className='blink'>_</span></h2>
                                <p className='pt-32'>
                                    Frontend and Full Stack Developer with 4+ years of experience in building scalable, responsive, and high-performance web applications. Skilled in React.js, Next.js, JavaScript, TypeScript, WordPress, and REST API integration. Passionate about creating clean user experiences, optimizing performance, and developing modern digital solutions from concept to deployment.
                                </p><div className="btn-bg mt-32">
                                    <a href="https://drive.google.com/file/d/1hqdZ3crHrh8uwWuW4SIYlRTMYak2R5H1/view?usp=sharing"><button className='download-btn w-fit'>Download Resume</button></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}